import { tokens } from "../../../../../theme/tokens";

interface StyleObject {
  [key: string]: React.CSSProperties;
}

export const styles: StyleObject = {
  inputStyle: {
    width: tokens.space[12],
    height: tokens.space[12],
    textAlign: "center",
    fontSize: tokens.fontSizes.lg,
    color: tokens.colors.textLight900,
    background: tokens.colors.backgroundDark100,
    borderRadius: tokens.radii.lg,
    borderWidth: tokens.space[0]
  }
};

export const mobileStyles = {
  containerStyle: {
    flexDirection: "row",
    flexWrap: "wrap",
    borderWidth: 1,
    gap: 0,
    alignItems: "flex-start",
    justifyContent: "space-evenly",
    paddingVertical: tokens.space[1],
    borderRadius: tokens.radii.xl,
    borderColor: tokens.colors.backgroundLight400
  } as const,
  textContainerStyle: {
    borderBottomWidth: tokens.radii.none,
    borderRadius: tokens.radii.lg,
    borderWidth: tokens.space[0],
    fontSize: tokens.fontSizes["3xl"],
    width: tokens.space[8],
    margin: 0
  } as const,
  textStyle: {
    color: tokens.colors.textLight900,
    fontWeight: tokens.fontWeights.medium
  }
};
